import React, { ReactElement, LinkHTMLAttributes, MouseEventHandler } from 'react';
import classNames from 'classnames';

import './link.scss';

export interface LinkProps extends LinkHTMLAttributes<HTMLAnchorElement> {
    type?: 'link' | 'button' | 'wrapper';
    color?: 'blue' | 'green' | 'white' | 'black';
    uppercase?: boolean;
    wrapper?: boolean;
    isDynamic?: boolean; // set to true when you don't want to reload whole page, but only change browser url
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    target?: '_blank';
}

const Link: React.FC<LinkProps> = (
    {
        href,
        type = 'link',
        color = type === 'link' ? 'blue' : 'green',
        uppercase,
        wrapper,
        isDynamic,
        className,
        onClick,
        children,
        ...props
    }
): ReactElement => {
    const linkClasses = ['link', {
        'link--uppercase': uppercase,
        'link--disabled': !href,
        [`link--color-${color}`]: !wrapper,
        'link--wrapper': wrapper
    }];
    const buttonClasses = ['button', {
        [`button--color-${color}`]: !wrapper,
        'button--uppercase': uppercase,
        'button--disabled': !href,
        'button--wrapper': wrapper
    }];
    const classes = classNames(
        className,
        type === 'link' ? linkClasses : buttonClasses
    );

    const handleOnClick: MouseEventHandler<HTMLAnchorElement> = e => {
        if (onClick) {
            onClick(e);
        }

        if (isDynamic) {
            e.preventDefault();
            history.replaceState('', '', href);
        }
    };

    return (
        <a href={href} className={classes} onClick={handleOnClick}
            {...props}
        >
            {children}
        </a>
    );
};

export default Link;
